import { useEffect, useState } from 'react';
import { upperFirst } from 'lodash-es';
import { Button, Typography, useStateInRef, useIsMounted, ProgressBar } from 'seagull';
import { ErrorBox, SuccessBox, ImportCard } from "./CommonComponents";
import styles from "./ImportWizard.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function SaveItemsStep(props) {
  const {
    saveEntityName,
    items,
    testid,
    currentSaveData,
    onReset,
    onEvent
  } = props;
  const isMounted = useIsMounted();
  const getStateInRef = useStateInRef(props);
  const [numberOfSavedItems, setNumberOfSavedItems] = useState(0);
  const [onStartSaveDone, setOnStartSaveDone] = useState(false);
  const [uploading, setUploading] = useState(true);
  const [saveFailed, setSaveFailed] = useState(false);
  const currentSaveNumSaved = currentSaveData ? currentSaveData.saved : numberOfSavedItems;
  const currentSaveEntityName = currentSaveData ? currentSaveData.entity : saveEntityName;
  const currentSaveTotal = currentSaveData ? currentSaveData.total : items.length;
  useEffect(() => {
    const {
      items,
      onStartSave
    } = getStateInRef();
    const startSave = async () => {
      if (onStartSave) {
        try {
          await onStartSave(items);
          setOnStartSaveDone(true);
        } catch (err) {
          setUploading(false);
          return setSaveFailed(true);
        }
      } else {
        setOnStartSaveDone(true);
      }
    };
    if (isMounted() && items) {
      startSave();
    }
  }, []);
  useEffect(() => {
    if (onStartSaveDone) {
      const {
        items
      } = getStateInRef();
      setOnStartSaveDone(false);
      const saveItems = async () => {
        let failedToSaveSomeDraft = false;
        let numOfSavedDrafts = 0;
        for (const item of items) {
          try {
            await getStateInRef().saveItem(item, numOfSavedDrafts, items);
            numOfSavedDrafts = numOfSavedDrafts + 1;
            setNumberOfSavedItems(numOfSavedDrafts);
          } catch (err) {
            failedToSaveSomeDraft = true;
          }
        }
        const {
          onEvent
        } = getStateInRef();
        onEvent && onEvent(failedToSaveSomeDraft ? 'afterSaveFailure' : 'afterSaveSuccess');
        setUploading(false);
        setSaveFailed(failedToSaveSomeDraft);
      };
      if (isMounted()) {
        saveItems();
      }
    }
  }, [onStartSaveDone]);
  return /*#__PURE__*/_jsx(ImportCard, {
    title: "Saving ".concat(upperFirst(currentSaveEntityName)),
    actionsEnd: /*#__PURE__*/_jsxs(_Fragment, {
      children: [saveFailed && /*#__PURE__*/_jsx(Button, {
        skin: "primaryOutline",
        disabled: uploading,
        onClick: onReset,
        children: "Restart"
      }), /*#__PURE__*/_jsxs(Button, {
        "data-testid": testid && testid + '-redirect-to-items',
        disabled: uploading || saveFailed,
        onClick: () => onEvent && onEvent('redirectToItems'),
        children: ["View ", saveEntityName]
      })]
    }),
    children: saveFailed ? /*#__PURE__*/_jsxs(ErrorBox, {
      "data-testid": testid && testid + '-save-error',
      children: ["Failed to save ", currentSaveEntityName, ". Please reset and start over.", !!(currentSaveData !== null && currentSaveData !== void 0 && currentSaveData.errorMsg) && /*#__PURE__*/_jsxs("div", {
        "data-testid": testid && testid + '-save-error-msg',
        children: ["Error: ", currentSaveData.errorMsg]
      })]
    }) : uploading ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ProgressBar, {
        className: styles.progressBar,
        completed: currentSaveNumSaved,
        total: currentSaveTotal,
        variant: "steps"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.progressStatus,
        children: [/*#__PURE__*/_jsxs(Typography, {
          children: ["Uploading and creating ", currentSaveEntityName, ". Please don't close this tab."]
        }), /*#__PURE__*/_jsx(Typography, {
          skin: "disabled",
          children: "".concat(currentSaveNumSaved, " / ").concat(currentSaveTotal, " ").concat(currentSaveEntityName)
        })]
      })]
    }) : /*#__PURE__*/_jsxs(SuccessBox, {
      "data-testid": testid && testid + '-save-success',
      children: [upperFirst(saveEntityName), " created successfully."]
    })
  });
}